import clsx from 'clsx';

import { INavigationNode } from '~/lib/data-contract';
import Link from '~/shared/components/Link/Link';
import { Text } from '~/shared/components/Text/Text';

import styles from './footerNavigation.module.css';

export type FooterNavigationProps = {
	title?: string;
	navigationItems?: INavigationNode[];
	enableMultiColumns?: boolean;
};

export const FooterNavigation = ({ navigationItems = [], title, enableMultiColumns }: FooterNavigationProps) => {
	return (
		<div>
			{title ? (
				<Text
					as="h3"
					variant="bodySmBold"
					marginBottom="2"
				>
					{title}
				</Text>
			) : null}
			<ul className={clsx(styles.root, enableMultiColumns && styles.enableRows)}>
				{navigationItems?.map((item) => {
					return (
						<li key={item.id}>
							<Link
								href={item.link.url}
								target={item.link.target}
							>
								{item.link.title ?? item.link.text}
							</Link>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
